import { inject } from '@angular/core';
import { Routes } from '@angular/router';

import { AnonymousUserGuard } from '@core/guards/anonymous-user.guard';
import { AuthGuard } from '@core/guards/authenticated-user.guard';
import { RouterPaths } from '@core/paths';
import { AuthService } from '@core/services/auth.service';
import { getLanguage } from '@core/utils';

import { APP_PATHS } from './app.paths';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: (): Promise<any> => import('./root-redirect.component').then(m => m.RootRedirectComponent),
  },
  {
    path: `:language/${APP_PATHS.HOME}`,
    canMatch: [AuthGuard],
    loadChildren: (): Promise<any> => import('@modules/main/main.routing').then(m => m.MAIN_ROUTES),
    title: 'categories.eskhata-business',
  },
  {
    path: `:language/${APP_PATHS.AUTH}`,
    canMatch: [AnonymousUserGuard],
    loadChildren: (): Promise<any> => import('@modules/auth/auth.routing').then(m => m.AUTH_ROUTES),
    title: 'page.eskhata-business',
  },
  {
    path: `:language/${APP_PATHS.home}`,
    loadComponent: (): any => import('@modules/landing-page/landing-page.component').then(m => m.LandingPageComponent),
    title: 'page.main-title',
    data: {
      meta: {
        description: 'page.main-description',
        keywords: 'page.main-keywords',
      },
    },
  },
  {
    path: `:language/${APP_PATHS.offlineRegistration}`,
    loadComponent: (): any =>
      import('@modules/landing-page/offline-registration/offline-registration.component').then(
        m => m.OfflineRegistrationComponent
      ),
  },
  {
    path: `:language/${APP_PATHS.onlineRegistration}`,
    loadComponent: (): any =>
      import('@modules/landing-page/online-registration/online-registration.component').then(
        m => m.OnlineRegistrationComponent
      ),
  },
  {
    path: '**',
    redirectTo: (): string => {
      const authService = inject(AuthService);

      return authService.isAuthenticated
        ? `/${getLanguage()}/${APP_PATHS.HOME}/${RouterPaths.Accounts.accounts}`
        : `/${getLanguage()}/${APP_PATHS.home}`;
    },
    pathMatch: 'full',
  },
];
